import React from "react";
import { createRoot } from "react-dom/client";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { RecoilRoot } from "recoil";
import { pdfjs } from "react-pdf";
// Styles
import "./styles/base.scss";
// Tailwind charge globalement, retire dans AdminLayout pour pages admin
import "./tailwind.css";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import "notyf/notyf.min.css";
import ErrorBoundary from "./components/WebSiteApp/Utilitaires/ErrorBoundary";
import { AuthProvider } from "./components/WebSiteApp/AuthContext";

// Configure PDF.js worker for Vite
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const initialOptions = {
  "client-id": import.meta.env.VITE_PAYPAL_KEY,
  currency: "EUR",
  intent: "capture",
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RecoilRoot>
        <AuthProvider>
          <ErrorBoundary>
            <PayPalScriptProvider options={initialOptions}>
              <App />
            </PayPalScriptProvider>
          </ErrorBoundary>
        </AuthProvider>
      </RecoilRoot>
    </BrowserRouter>
  </React.StrictMode>
);
